import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'
import { SignatureState } from '../types'

export const getters: GetterTree<SignatureState, RootState> = {}

export default getters
